import { gql } from '@apollo/client';

const createTax = gql`
  mutation ($input: TaxInput!) {
    createTax(input: $input)
  }
`;
export default createTax;
